import * as R from 'ramda'

import { Nil } from '../types'

export const splitBetweenIndexes = (
  [from, to, ...rest]: number[],
  str: string,
): string[] =>
  from !== undefined && to !== undefined
    ? [str.substring(from, to), ...splitBetweenIndexes([to, ...rest], str)]
    : []
/**
 * Returns combined array of start and end index for each match
 * @param str - text to search in
 * @param term - term to search for
 * @param startIndex=0 - index to start from
 */
export const keysInsensitiveSearch = (
  str: string | Nil,
  term: string,
  startIndex: number = 0,
): number[] => {
  const index = (str || '').toLowerCase().indexOf(term, startIndex)

  return index === -1
    ? []
    : [
      index,
      index + term.length,
      ...keysInsensitiveSearch(str, term, index + term.length),
    ]
}

/**
 * Splits string using term into parts ignoring register
 * @param str - text to be split by term
 * @param term - term to split by
 */
const keysInsensitiveSplit = (str: string, term: string) => {
  const indexes = R.uniq([0, ...keysInsensitiveSearch(str, term), str.length])
  return splitBetweenIndexes(indexes, str)
}

/**
 * Splits string using term into parts ignoring register, and returns parts with a `bold` flag
 * @param str - text to be split by term and highlighted
 * @param term - term to split by
 */
const keyInsensitiveHighlight = (str: string, term: string) => {
  if (!term) {
    return [{ text: str }]
  }

  const termLowerCase = term.toLowerCase()
  return keysInsensitiveSplit(str, termLowerCase).map(text => ({
    text,
    bold: text.toLowerCase() === termLowerCase,
  }))
}

export default keyInsensitiveHighlight
